import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWsLogo100Light = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 212 141"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="ws-logo-100-light_svg__a"
      width={103}
      height={103}
      x={81}
      y={37}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M132.334 139.692c28.133 0 50.938-22.885 50.938-51.116 0-28.233-22.805-51.118-50.938-51.118S81.396 60.343 81.396 88.576c0 28.231 22.805 51.116 50.938 51.116"
      />
    </mask>
    <g mask="url(#ws-logo-100-light_svg__a)">
      <mask
        id="ws-logo-100-light_svg__b"
        width={212}
        height={141}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 141h212V0H0z"
        />
      </mask>
      <g mask="url(#ws-logo-100-light_svg__b)">
        <path
          fill="#60D259"
          d="M73.715 141h117.239V29.71H73.714z"
        />
      </g>
    </g>
    <mask
      id="ws-logo-100-light_svg__c"
      width={152}
      height={43}
      x={0}
      y={76}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="m96.83 78.083 5.707-1.413v4.305h4.746a12.4 12.4 0 0 0-2.676 4.52h-2.07v5.906q0 1.005.876 1.005c.264 0 .664-.07 1.054-.187a12.1 12.1 0 0 0 1.965 3.951c-1.205.69-2.933 1.166-4.523 1.166q-2.35 0-3.715-1.444-1.362-1.444-1.364-4.051v-6.345h-2.35v-4.521h2.35zm39.297-1.664h5.724v20.605h-5.409v-1.785q-.534 1.127-1.793 1.612a6.9 6.9 0 0 1-2.484.485q-3.274 0-5.128-2.347-1.855-2.35-1.856-5.951.001-3.601 1.919-5.966c1.28-1.576 3.028-2.362 5.252-2.362 1.657 0 2.915.55 3.775 1.66zm-4.403 14.983q.723.925 1.856.925 1.131 0 1.854-.925.725-.923.724-2.364.001-1.44-.724-2.38-.723-.94-1.854-.94-1.133 0-1.856.94t-.724 2.38.724 2.364m-23.118-8.345q1.855-2.347 5.126-2.347 1.228-.001 2.484.484 1.26.485 1.794 1.612v-1.785h5.409v16.002h-5.409V95.24q-.535 1.127-1.794 1.612a6.9 6.9 0 0 1-2.484.485q-3.271 0-5.126-2.347-1.857-2.35-1.856-5.951-.001-3.633 1.856-5.981m4.686 8.345q.722.925 1.856.925 1.131 0 1.856-.925.722-.923.722-2.364t-.722-2.38q-.725-.94-1.856-.94-1.133 0-1.856.94t-.725 2.38q.001 1.44.725 2.364m-31.439-9.284q1.935-1.409 4.67-1.408 3.682 0 6.511 1.502l-1.697 3.82q-2.422-.94-4.626-.94-1.005-.001-1.006.503 0 .376.819.655.818.284 1.981.597 1.164.315 2.343.797 1.179.486 1.999 1.566.816 1.081.817 2.615 0 1.504-.756 2.647a4.93 4.93 0 0 1-1.95 1.737 10.46 10.46 0 0 1-4.687 1.127q-4.466 0-6.666-1.91l1.824-4.007a8.2 8.2 0 0 0 2.09 1.017q1.054.329 2.785.328.126 0 .439-.045.315-.049.726-.222.408-.171.407-.452 0-.159-.094-.25a1 1 0 0 0-.313-.19 4 4 0 0 0-.378-.14 8 8 0 0 0-.552-.127l-.55-.108q-2.895-.69-4.481-1.91-1.59-1.221-1.589-3.289 0-2.503 1.935-3.913m-14.478.658q1.793-2.067 4.844-2.066 1.477-.001 2.562.484 1.085.486 1.668 1.175.581.687.911 1.752.332 1.065.407 1.943.08.877.08 2.034v8.926h-5.723v-8.205q0-2.787-1.794-2.788-1.227 0-1.934.957-.708.955-.708 2.488v7.547h-5.724V81.022h5.41zm-22.207.344q2.504-2.411 6.18-2.41 3.683-.001 6.182 2.41t2.5 5.918q0 3.476-2.5 5.888-2.5 2.41-6.181 2.41-3.678 0-6.18-2.41t-2.502-5.888q.001-3.506 2.501-5.918m4.088 8.282q.803.925 2.093.925t2.092-.925q.802-.923.802-2.364t-.818-2.38q-.818-.94-2.076-.94-1.256 0-2.076.94c-.544.626-.82 1.42-.82 2.38q.002 1.44.803 2.364M26.273 83.12q2.497-2.411 6.18-2.41 3.678-.001 6.18 2.41 2.5 2.412 2.501 5.918 0 3.476-2.5 5.888-2.504 2.41-6.181 2.41-3.682 0-6.18-2.41-2.503-2.41-2.502-5.888 0-3.506 2.502-5.918m4.087 8.282q.802.925 2.093.925t2.09-.925q.802-.923.802-2.364t-.816-2.38q-.82-.94-2.076-.94-1.259 0-2.077.94t-.817 2.38.801 2.364M17.771 81.02h5.568l-4.846 16.004h-5.22l-1.604-9.333-1.604 9.332H4.844L0 81.022h5.567l1.92 9.332 1.351-9.332h5.66l1.354 9.332zM144.45 93.964a3.447 3.447 0 0 1 3.443-3.453 3.45 3.45 0 0 1 3.443 3.453 3.45 3.45 0 0 1-3.443 3.454 3.45 3.45 0 0 1-3.443-3.454m-75.29 22.346.39-.249.542.985-.07.057c-.797.638-1.746.961-2.825.961-.963 0-1.77-.327-2.395-.969-.623-.644-.94-1.748-.94-3.282v-7.528h-6.996v7.528c0 2.085.697 3.1 2.135 3.1.386 0 .773-.068 1.15-.203s.652-.27.814-.4l.39-.249.54.985-.069.057c-.796.638-1.748.961-2.825.961-.963 0-1.77-.327-2.395-.969-.625-.645-.94-1.748-.94-3.282v-7.528h-1.9v-1.151h1.9v-3.102h1.2v3.102h6.996v-3.102h1.198v3.102h4.821v1.151h-4.82v7.528c0 2.085.699 3.1 2.136 3.1.384 0 .772-.068 1.15-.203s.653-.27.814-.4m-35.657-8.653c1.002-1.847 2.69-2.783 5.025-2.783h.105v1.334h-.105a5.6 5.6 0 0 0-1.726.267 5.5 5.5 0 0 0-1.61.858c-.512.386-.925.958-1.228 1.701-.306.747-.461 1.635-.461 2.642v6.127h-1.2v-12.669h1.2zm16.427 7.659c1.034-1.06 1.557-2.355 1.557-3.848s-.523-2.787-1.557-3.847c-1.032-1.06-2.304-1.596-3.78-1.596-1.474 0-2.745.536-3.778 1.596s-1.558 2.355-1.558 3.847c0 1.493.526 2.788 1.558 3.848s2.306 1.597 3.779 1.597c1.475 0 2.747-.537 3.78-1.597m-3.78-10.442c1.81 0 3.379.651 4.66 1.932 1.283 1.283 1.931 2.853 1.931 4.662 0 1.81-.648 3.38-1.931 4.662-1.281 1.284-2.85 1.934-4.66 1.934-1.806 0-3.374-.65-4.657-1.934-1.281-1.282-1.932-2.852-1.932-4.662 0-1.809.65-3.379 1.932-4.662 1.281-1.281 2.851-1.932 4.658-1.932m26.39 5.992h9.69c-.12-1.327-.632-2.47-1.522-3.401-.914-.956-2.009-1.441-3.258-1.441-1.268 0-2.384.485-3.323 1.442-.914.93-1.448 2.073-1.587 3.4m4.91-5.994c1.656 0 3.096.648 4.285 1.923 1.182 1.275 1.785 2.811 1.785 4.568l-.033.655H72.54c.14 1.359.697 2.52 1.662 3.451.992.956 2.187 1.443 3.56 1.443 1.609 0 2.967-.611 4.036-1.815l.072-.082.833.801-.07.078c-1.352 1.439-2.991 2.169-4.87 2.169-1.776 0-3.317-.65-4.581-1.934s-1.907-2.849-1.907-4.661c0-1.809.61-3.377 1.814-4.66 1.204-1.285 2.67-1.936 4.36-1.936m63.462 1.232c.788.817 1.187 1.98 1.187 3.463v8.236h-1.199v-7.951c0-1.253-.274-2.217-.808-2.863-.532-.64-1.424-.965-2.655-.965a4.06 4.06 0 0 0-2.819 1.092c-.79.725-1.189 1.706-1.189 2.919v7.768h-1.202v-7.951c0-1.253-.272-2.217-.807-2.863-.532-.64-1.424-.965-2.653-.965-1.044 0-1.984.402-2.792 1.194-.808.794-1.216 1.795-1.216 2.972v7.613h-1.202v-12.669h1.202v1.911c.923-1.443 2.313-2.171 4.137-2.171 2.071 0 3.459.827 4.134 2.463a4.77 4.77 0 0 1 1.844-1.802 5.65 5.65 0 0 1 2.695-.661c1.429 0 2.553.412 3.343 1.23m-53.736 1.553c1.002-1.847 2.69-2.783 5.023-2.783h.107v1.334h-.107c-.594 0-1.174.09-1.725.267a5.6 5.6 0 0 0-1.61.858c-.513.386-.924.959-1.229 1.701-.305.747-.459 1.635-.459 2.642v6.127h-1.203v-12.669h1.203zm30.359 7.699c.976-1.033 1.469-2.341 1.469-3.888 0-1.493-.489-2.789-1.455-3.848-.965-1.059-2.165-1.595-3.569-1.595s-2.605.536-3.567 1.595c-.966 1.059-1.458 2.355-1.458 3.848s.492 2.789 1.458 3.849c.962 1.06 2.164 1.596 3.567 1.596 1.386 0 2.584-.523 3.555-1.557m1.469-7.609v-2.613h1.202v12.669h-1.202v-2.611a5.9 5.9 0 0 1-1.933 2.009c-.908.57-1.948.862-3.091.862-1.722 0-3.215-.65-4.44-1.934-1.219-1.283-1.837-2.851-1.837-4.661s.618-3.376 1.837-4.659c1.221-1.284 2.716-1.935 4.44-1.935 1.143 0 2.183.29 3.091.863a5.85 5.85 0 0 1 1.933 2.01m-16.182 7.621c.974-1.025 1.469-2.338 1.469-3.9 0-1.495-.488-2.79-1.456-3.85-.963-1.058-2.163-1.594-3.567-1.594s-2.606.536-3.569 1.594c-.967 1.06-1.458 2.355-1.458 3.85 0 1.494.491 2.789 1.458 3.851.963 1.057 2.166 1.593 3.569 1.593 1.386 0 2.582-.519 3.554-1.544m1.469-7.623v-7.303h1.202v17.361h-1.202v-2.612a5.86 5.86 0 0 1-1.935 2.009c-.905.573-1.946.863-3.088.863-1.724 0-3.219-.65-4.44-1.935-1.22-1.283-1.837-2.851-1.837-4.66s.617-3.377 1.837-4.66c1.221-1.285 2.716-1.936 4.44-1.936 1.142 0 2.183.292 3.088.863a5.9 5.9 0 0 1 1.935 2.01"
      />
    </mask>
    <g mask="url(#ws-logo-100-light_svg__c)">
      <mask
        id="ws-logo-100-light_svg__d"
        width={212}
        height={141}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 141h212V0H0z"
        />
      </mask>
      <g mask="url(#ws-logo-100-light_svg__d)">
        <path
          fill="#fff"
          d="M0 125.811h159.015v-57.14H0z"
        />
      </g>
    </g>
    <mask
      id="ws-logo-100-light_svg__e"
      width={16}
      height={16}
      x={195}
      y={123}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M203.099 138.863c4.105 0 7.432-3.404 7.432-7.6s-3.327-7.597-7.432-7.597-7.434 3.401-7.434 7.597 3.328 7.6 7.434 7.6"
      />
    </mask>
    <g mask="url(#ws-logo-100-light_svg__e)">
      <mask
        id="ws-logo-100-light_svg__f"
        width={212}
        height={141}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 141h212V0H0z"
        />
      </mask>
      <g mask="url(#ws-logo-100-light_svg__f)">
        <path
          fill="#FF7840"
          d="M187.984 141h30.229v-25.081h-30.229z"
        />
      </g>
    </g>
    <mask
      id="ws-logo-100-light_svg__g"
      width={39}
      height={40}
      x={168}
      y={5}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M187.403 44.367c10.645 0 19.274-8.66 19.274-19.341 0-10.683-8.629-19.34-19.274-19.34-10.644 0-19.273 8.657-19.273 19.34 0 10.681 8.629 19.341 19.273 19.341"
      />
    </mask>
    <g mask="url(#ws-logo-100-light_svg__g)">
      <mask
        id="ws-logo-100-light_svg__h"
        width={212}
        height={141}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 141h212V0H0z"
        />
      </mask>
      <g mask="url(#ws-logo-100-light_svg__h)">
        <path
          fill="#F26FB9"
          d="M160.449 52.114h53.909V-2.062h-53.909z"
        />
      </g>
    </g>
    <mask
      id="ws-logo-100-light_svg__i"
      width={24}
      height={25}
      x={35}
      y={22}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="m47.603 22.541-.075-.001c-6.54 0-11.84 5.32-11.84 11.88 0 6.563 5.3 11.882 11.84 11.882 5.14 0 9.514-3.288 11.15-7.882-6.11-2.854-10.479-8.826-11.075-15.879"
      />
    </mask>
    <g mask="url(#ws-logo-100-light_svg__i)">
      <mask
        id="ws-logo-100-light_svg__j"
        width={212}
        height={141}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 141h212V0H0z"
        />
      </mask>
      <g mask="url(#ws-logo-100-light_svg__j)">
        <path
          fill="#00C5F4"
          d="M28.007 54.05h38.352V14.792H28.007z"
        />
      </g>
    </g>
    <mask
      id="ws-logo-100-light_svg__k"
      width={40}
      height={40}
      x={47}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M66.802 1.54c-10.645 0-19.274 8.66-19.274 19.342 0 .56.03 1.111.075 1.66 6.505.04 11.764 5.342 11.764 11.878 0 1.403-.244 2.75-.689 4a19.1 19.1 0 0 0 8.124 1.802c10.646 0 19.273-8.658 19.273-19.34S77.448 1.54 66.802 1.54"
      />
    </mask>
    <g mask="url(#ws-logo-100-light_svg__k)">
      <mask
        id="ws-logo-100-light_svg__l"
        width={212}
        height={141}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 141h212V0H0z"
        />
      </mask>
      <g mask="url(#ws-logo-100-light_svg__l)">
        <path
          fill="#0076DD"
          d="M39.847 47.97h53.91V-6.208h-53.91z"
        />
      </g>
    </g>
    <mask
      id="ws-logo-100-light_svg__m"
      width={13}
      height={17}
      x={47}
      y={22}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M47.603 22.541c.596 7.054 4.965 13.025 11.075 15.88.445-1.251.69-2.596.69-4 0-6.537-5.26-11.84-11.765-11.88"
      />
    </mask>
    <g mask="url(#ws-logo-100-light_svg__m)">
      <mask
        id="ws-logo-100-light_svg__n"
        width={212}
        height={141}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 141h212V0H0z"
        />
      </mask>
      <g mask="url(#ws-logo-100-light_svg__n)">
        <path
          fill="#001D5B"
          d="M39.922 46.168H67.05V14.794H39.922z"
        />
      </g>
    </g>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWsLogo100Light);

export default ForwardRef;
